module.exports = __webpack_public_path__ + "img/GAME_COUNTCHICKS1.60302ce2.jpg";